import {frontend} from 'pageflow-scrolled/frontend';

import {Faq} from './Faq';

frontend.contentElementTypes.register('faq', {
  component: Faq
});
